import { useState } from "react";
import { makeStyles } from "tss-react/mui";
import { MiFilterItem, MiIcon, MiInputTextbox } from "@miplatform/components";
import { ICONS_WEB } from "@miplatform/constants";
import { useDebounce } from "@miplatform/hooks";
import * as mdi from "@mdi/js";
import { Box, InputAdornment } from "@mui/material";
import { EmptySearchResults } from "../../../../../../components/EmptySearchResults/EmptySearchResults";

export function AddAreaTemplate({
  areaTemplates = [],
  selectedAreaTemplate,
  setSelectedAreaTemplate,
}) {
  const { classes, theme } = useStyles();
  const [search, setSearch] = useState("");

  const debouncedSearch = useDebounce(search, 300);

  const filteredAreaTemplates =
    areaTemplates?.filter((template) =>
      template?.name.toLowerCase().includes(debouncedSearch.toLowerCase())
    ) ?? [];

  const isSelected = (id) => selectedAreaTemplate?.id === id;

  return (
    <Box className={classes.root}>
      <MiInputTextbox
        style={{ padding: theme.spacing(3) }}
        placeholder="Search Area Templates"
        value={search}
        handleChange={(e) => setSearch(e.target.value)}
        name="area-template-search"
        textfieldProps={{
          startAdornment: (
            <InputAdornment position="start">
              <MiIcon path={mdi[ICONS_WEB.MAGNIFY]} size={0.8} />
            </InputAdornment>
          ),
          endAdornment: search && (
            <InputAdornment position="end" sx={{ cursor: "pointer" }}>
              <MiIcon
                path={mdi[ICONS_WEB.CLOSE]}
                onClick={() => setSearch("")}
                size={0.8}
              />
            </InputAdornment>
          ),
        }}
      />
      {filteredAreaTemplates.length === 0 ? (
        <EmptySearchResults />
      ) : (
        <Box className={classes.filterList}>
          {filteredAreaTemplates?.map((item) => (
            <MiFilterItem
              key={item.id}
              keyVal={item.id}
              title={item.name}
              handleClick={() =>
                setSelectedAreaTemplate(!isSelected(item.id) ? item : null)
              }
              selected={isSelected(item.id)}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
    padding: theme.spacing(0, 0),
    display: "flex",
    flexDirection: "column",
  },
  searchInput: {
    padding: theme.spacing(3),
  },
  filterList: {
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
}));
